<template lang="pug">
.form-input-standard-user-send-messages-function.w-100
  .content.d-flex.flex-row.align-items-center
    span.error-message 詳細設定はメッセージ送信を使用可にしないと有効になりません。

  //- 基本設定の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getSendMessagesFunctionName("useBasicSetting") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useBasicSetting")
  //- テンプレートの使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getSendMessagesFunctionName("useTemplate") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useTemplate")
  //- 一時保存の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getSendMessagesFunctionName("useSaveDraftMessage") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useSaveDraftMessage")
  //- 新規送信の「送信」、メッセージ詳細の返信リストの「送信」の使用可否
  .content.d-flex.flex-row.align-items-center
    .function-detail-name.flex-grow-1
      span {{ getSendMessagesFunctionName("useSendAndReply") }}
    .d-flex.flex-row-reverse
      UsableFunctionSwitch(v-model="_value.useSendAndReply")

  //- 家族連絡サービス
  template(v-if="_useFamilyService && _isOverLightPlan && serviceType == 'families'")
    //- 宛先種別の「家族全員」の使用可否
    .content.d-flex.flex-row.align-items-center
      .function-detail-name.flex-grow-1
        span {{ getSendMessagesFunctionName("useSendTargetToAllFamily") }}
      .d-flex.flex-row-reverse
        UsableFunctionSwitch(v-model="_value.useSendTargetToAllFamily")
    //- 宛先種別の「家族個別」の使用可否
    .content.d-flex.flex-row.align-items-center
      .function-detail-name.flex-grow-1
        span {{ getSendMessagesFunctionName("useSendTargetToFamily") }}
      .d-flex.flex-row-reverse
        UsableFunctionSwitch(v-model="_value.useSendTargetToFamily")
    //- 宛先種別の「施設関係者個別」の使用可否
    .content.d-flex.flex-row.align-items-center
      .function-detail-name.flex-grow-1
        span {{ getSendMessagesFunctionName("useSendTargetToOtherUser") }}
      .d-flex.flex-row-reverse
        UsableFunctionSwitch(v-model="_value.useSendTargetToOtherUser")
    //- 宛先種別のグループ「宛先グループ（家族）」の使用可否
    .content.d-flex.flex-row.align-items-center
      .function-detail-name.flex-grow-1
        span {{ getSendMessagesFunctionName("useSendTargetToFamilySendMessageGroup") }}
      .d-flex.flex-row-reverse
        UsableFunctionSwitch(v-model="_value.useSendTargetToFamilySendMessageGroup")
    //- 宛先種別のグループ「宛先グループ（施設関係者）」の使用可否
    .content.d-flex.flex-row.align-items-center
      .function-detail-name.flex-grow-1
        span {{ getSendMessagesFunctionName("useSendTargetToOtherUserSendMessageGroup") }}
      .d-flex.flex-row-reverse
        UsableFunctionSwitch(v-model="_value.useSendTargetToOtherUserSendMessageGroup")
    //- 宛先種別のグループ「利用者グループ」の使用可否
    .content.d-flex.flex-row.align-items-center
      .function-detail-name.flex-grow-1
        span {{ getSendMessagesFunctionName("useSendTargetToResidentGroup") }}
      .d-flex.flex-row-reverse
        UsableFunctionSwitch(v-model="_value.useSendTargetToResidentGroup")
    //- 宛先種別のグループ「施設関係者グループ」の使用可否
    .content.d-flex.flex-row.align-items-center
      .function-detail-name.flex-grow-1
        span {{ getSendMessagesFunctionName("useSendTargetToOtherUserGroup") }}
      .d-flex.flex-row-reverse
        UsableFunctionSwitch(v-model="_value.useSendTargetToOtherUserGroup")

  //- 待機者管理サービス
  template(v-if="_useWaiterService && _isOverWaiterBasicPlan && serviceType == 'waiters'")
    //- 宛先種別の「入所申込者全員」の使用可否
    .content.d-flex.flex-row.align-items-center
      .function-detail-name.flex-grow-1
        span {{ getSendMessagesFunctionName("useSendTargetToAllWaiter") }}
      .d-flex.flex-row-reverse
        UsableFunctionSwitch(v-model="_value.useSendTargetToAllWaiter")
    //- 宛先種別の「入所申込者個別」の使用可否
    .content.d-flex.flex-row.align-items-center
      .function-detail-name.flex-grow-1
        span {{ getSendMessagesFunctionName("useSendTargetToWaiter") }}
      .d-flex.flex-row-reverse
        UsableFunctionSwitch(v-model="_value.useSendTargetToWaiter")
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import { SendMessagesFunction, sendMessagesFunctionNameMap } from "@/commons/services/Authorization";

import UsableFunctionSwitch from "@/pc/basics/UsableFunctionSwitch.vue";
import { PlanType } from "@/commons/services/Plans";
import { WaiterServicePlanType } from "@/commons/services/WaiterServicePlans";

/**
 * ### 一般ユーザーの使用機能選択コンポーネント(メッセージ送信)
 */
@Component({
  components: {
    UsableFunctionSwitch
  }
})
export default class FormInputStandardUserSendMessagesFunction extends Vue {
  /** 親コンポーネントでv-modelで指定した値 */
  @Prop()
  value!: SendMessagesFunction;

  @Prop()
  serviceType!: ServiceType;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): SendMessagesFunction {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: SendMessagesFunction) {
    this.$emit("input", newValue);

    return;
  }

  get _useFamilyService(): boolean {
    return userStore.facility.useFamilyService;
  }

  get _useWaiterService(): boolean {
    return userStore.facility.useWaiterService && userStore.loginUser.permissions.functions.useWaiterService;
  }

  /** ### プランがライト以上かを返す */
  get _isOverLightPlan(): boolean {
    const planType: PlanType = userStore.facility.planType;

    if (PlanType.LIGHT <= planType) {
      return true;
    } else {
      return false;
    }
  }

  /** ### プラン(待機者)がベーシック以上かを返す */
  get _isOverWaiterBasicPlan(): boolean {
    const planType: WaiterServicePlanType = userStore.facility.waiterServicePlanType;

    if (WaiterServicePlanType.BASIC <= planType) {
      return true;
    } else {
      return false;
    }
  }

  /**
   * ### メッセージ送信の項目名を返す
   */
  public getSendMessagesFunctionName(functionKeyName: string): string {
    const functionName: string | undefined = sendMessagesFunctionNameMap.get(functionKeyName);
    return functionName ? functionName : "";
  }
}
export enum ServiceType {
  /** 家族連絡 */
  FAMILIES = "families",
  /** 入所者募集管理 */
  WAITERS = "waiters"
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

.form-input-standard-user-send-messages-function {
  margin-bottom: 12px;
  padding: 12px 12px 4px 12px;

  background-color: $hitomeq-gray;

  .content {
    margin-bottom: 8px;
    padding-right: 74px;

    .function-detail-name {
      margin-left: 16px;
    }
  }
}
</style>
